/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 7/12/2024
 */

import { ImageList, ImageListItem } from '@mui/material'
import React, { useState } from 'react'
import styles from "./RequestImages.module.css";
import EnlargedImage from './EnlargedImage';

const RequestImages = ({ images, col }) => {
    const [selectedImg, setSelectedImg] = useState("")
    const [open, setOpen] = useState(false)

    const onOpenImage = (img) => {
        setOpen(true)
        setSelectedImg(img)
    }

    return (
        <div className={styles.container}>
            <ImageList className={styles.imgList} gap={5} cols={col} rowHeight={110}>
                {images?.length !== 0 &&
                images?.map((img, index) => (
                    <div key={index} className={styles.itemContainer}>
                        <ImageListItem>
                            <img
                                src={`${img.image}`}
                                alt=""
                                className={styles.image}
                                loading='lazy'
                                onClick={() => onOpenImage(img.image)}
                            />
                        </ImageListItem>
                    </div>
                ))}
            </ImageList>
            <EnlargedImage open={open} onClose={() => setOpen(false)} image={selectedImg} />
        </div>
    )
}

export default RequestImages